export const GET_NOTIFICATION = "GET_NOTIFICATION";
export const READ_NOTIFICATION="READ_NOTIFICATION";
export const UNREAD_COUNT="UNREAD_COUNT";
export const READ_ALL_NOTIFICATION='READ_ALL_NOTIFICATION'
export const VERIFY_LOADING = "VERIFY_LOADING";
export const VERIFY_ERROR = "VERIFY_ERROR";